"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var CompressedModelDetails = /** @class */ (function () {
    function CompressedModelDetails() {
    }
    CompressedModelDetails.fromJson = function (key, json) {
        var compressedModelDetails = new CompressedModelDetails();
        compressedModelDetails.key = key;
        compressedModelDetails.model = DataItem_1.DataItem.fromJson(Field_1.FIELD.MODEL, json[Field_1.FIELD.MODEL]);
        compressedModelDetails.name = DataItem_1.DataItem.fromJson(Field_1.FIELD.NAME, json[Field_1.FIELD.NAME]);
        compressedModelDetails.typeId = DataItem_1.DataItem.fromJson(Field_1.FIELD.TYPEID, json[Field_1.FIELD.TYPEID]);
        compressedModelDetails.version = DataItem_1.DataItem.fromJson(Field_1.FIELD.VERSION, json[Field_1.FIELD.VERSION]);
        compressedModelDetails.content = DataItem_1.DataItem.fromJson(Field_1.FIELD.CONTENT, json[Field_1.FIELD.CONTENT]);
        return compressedModelDetails;
    };
    CompressedModelDetails.prototype.toJson = function () {
        var _a;
        var json = Object.create(null);
        json[this.key] = (_a = {},
            _a[Field_1.FIELD.MODEL] = this.model.toJson(true),
            _a[Field_1.FIELD.NAME] = this.name.toJson(true),
            _a[Field_1.FIELD.TYPEID] = this.typeId.toJson(true),
            _a[Field_1.FIELD.VERSION] = this.version.toJson(true),
            _a[Field_1.FIELD.CONTENT] = this.content.toJson(true),
            _a);
        return json;
    };
    return CompressedModelDetails;
}());
exports.CompressedModelDetails = CompressedModelDetails;
//# sourceMappingURL=CompressedModelDetails.js.map